<!--
 * @Author: Jason
 * @Date: 2020-09-11 16:39:04
 * @LastEditors: Jason
 * @LastEditTime: 2020-10-10 16:21:20
-->
<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-document"></i> 护士站信息
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="form-box" v-if="Nurse.current">
        <el-form ref="form" :model="Nurse.current" label-width="80px">
          <el-form-item label="护士站ID:">{{Nurse.current.id}}</el-form-item>
          <el-form-item label="名称:">{{Nurse.current.name}}</el-form-item>
          <el-form-item label="账号:">{{Nurse.current.mobile}}</el-form-item>
          <el-form-item label="密码:">{{Nurse.current.password}}</el-form-item>
        </el-form>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["Nurse"])
  },
  data() {
    return {
      id: 0
    }
  },
  watch: {
  },
  created() {
    this.id = this.$route.params.id
    this.getData();
  },
  methods: {
    getData() {
      this.$api.getNurseById(this.id);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/NurseDetail.vue